import React, { Component, Fragment } from 'react'
import styled, { withTheme } from 'styled-components'
import TitleTopic from '../../../../components/TitleTopic'
import CategoryArticlesPanel from '../../../../components/CategoryArticlesPanel'
import Block from '../../../../layouts/Blocks'
import PropTypes from 'prop-types'
import hasItems from '../../../../modules/has-items'
import LoadMore from '../../../../components/LoadMore'
import isServerSide from '../../../../modules/is-server-side'

const Wrapper = styled.div``

class ListDepartment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      helperArticles: props.data.articles,
    }
  }

  render() {
    const {
      data: { title, articles },
      ...props
    } = this.props

    return (
      <Wrapper {...props}>
        <TitleTopic view="screen" title={title} />
        {hasItems(articles) && (
          <CategoryArticlesPanel articles={this.state.helperArticles} disable={!this.props.data.locale}>
            {(categoryArticles) => (
              <Fragment>
                <Block data={{ articles: [categoryArticles[0]] }} view="big_one_article" />
                <Block
                  data={{ articles: [categoryArticles[1], categoryArticles[2], categoryArticles[3]] }}
                  view="three_landscape_article"
                  adIds={props.theme.mode === 'tablet' ? ['S5', 'S6'] : ['S5']}
                />
                <Block
                  data={{ articles: [categoryArticles[4], categoryArticles[5], categoryArticles[6]] }}
                  view="three_landscape_article"
                  adIds={props.theme.mode !== 'tablet' && ['S6']}
                />
                <Block data={{ articles: categoryArticles.slice(7) }} view="articles" />
                {!isServerSide() && (
                  <LoadMore
                    articles={articles}
                    afterLoadMore={(newArticles) => {
                      this.setState({ helperArticles: newArticles })
                    }}
                  />
                )}
              </Fragment>
            )}
          </CategoryArticlesPanel>
        )}
      </Wrapper>
    )
  }
}

ListDepartment.propTypes = {
  data: PropTypes.shape({
    ...TitleTopic.propTypes,
  }),
}

export default withTheme(ListDepartment)
